import { render } from "./PopupRendererComponent.vue?vue&type=template&id=0d2788c6&scoped=true"
import script from "./PopupRendererComponent.vue?vue&type=script&lang=js"
export * from "./PopupRendererComponent.vue?vue&type=script&lang=js"

import "./PopupRendererComponent.vue?vue&type=style&index=0&id=0d2788c6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d2788c6"]])

export default __exports__